import { render, staticRenderFns } from "./editVehicleFitness.vue?vue&type=template&id=70b00758"
import script from "./editVehicleFitness.vue?vue&type=script&lang=js"
export * from "./editVehicleFitness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports